import { DocumentView } from "./views/DocumentView"

export const DOCUMENTS_ROUTES = [
  {
    path: "/document",
    component: DocumentView
  }
]
